import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { useGetNetworksPaginatedFormValidation } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/networks/models/inputs/get-networks-paginated.form-validation';
import { GetNetworksPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/networks/models/inputs/get-networks-paginated.model';
import { Controller, useFormContext } from 'react-hook-form';

import { CustomerFilterController } from '@app/feature/customer/customer-filter/customer-filter.controller';

const NetworkListFilterFormStep1CustomerIdFragment = (): React.JSX.Element => {
  // CONTEXT /////////////////////////////////////////////////////////////////

  // const { t } = useTranslation();
  const { control } = useFormContext<GetNetworksPaginatedModel>();
  const { customerId } = useGetNetworksPaginatedFormValidation();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Controller
      name="customerId"
      control={control}
      rules={customerId}
      render={({ field /* , fieldState: { error } */ }) => {
        const values = [];

        if (Array.isArray(field.value)) {
          values.push(...field.value);
        } else if (field.value) {
          values.push(field.value);
        }

        return (
          <CustomerFilterController
            selectedItemIds={values}
            onChange={(value) => field.onChange(value)}
          />
        );
      }}
    />
  );
};

export const NetworkListFilterFormStep1Controller = (): React.JSX.Element => {
  // RENDER //////////////////////////////////////////////////////////////////

  return (
    <Stack
      direction="row"
      justifyContent="stretch"
      alignItems="stretch"
      flex={1}
      gap={GapEnum.XL}>
      <Stack direction="column" flex={1} alignItems="stretch" gap={GapEnum.XL}>
        <NetworkListFilterFormStep1CustomerIdFragment />
      </Stack>
    </Stack>
  );
};
